/* ------------------------------------------------------------------
   File: routesConfig.js
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-08-24
------------------------------------------------------------------ */

// Purpose:
//   - routesConfig defines all fixed route paths and dynamic route patterns.
//   - routeBuilders generates real URLs for dynamic content.

export const routesConfig = {
  home: "/",

  // ====== ABOUT US PATHS ========================
  about: "/about",
  aboutPhilosophy: "/about/philosophy",
  aboutLeadership: "/about/leadership",
  aboutGovernance: "/about/governance",
  aboutHoldingModel: "/about/holding-model",
  aboutOperatingCompanies: "/about/operating-companies",
  aboutBusinessDivisions: "/about/business-divisions",
  aboutSectorFocus: "/about/sector-focus",
  aboutPartnerships: "/about/partnerships",
  aboutSustainabilityAndImpact: "/about/sustainability-and-impact",
  aboutAccendGroup: "/about/accend-group",
  aboutGroupApproach: "/about/accend-group/group-approach",
  // Bookmarks
  aboutWhoWeAre: "/about#who-we-are",
  aboutOurPurpose: "/about#our-purpose",
  aboutMissionVision: "/about#mission-and-vision",

  // ====== BUSINESSES PATHS ========================
  businesses: "/businesses",
  businessesPortfolioOverview: "/businesses/portfolio",
  businessesGroupCompanies: "/businesses/companies",
  businessesOperatingSectors: "/businesses/sectors",
  businessesSector: "/businesses/sectors/:sectorSlug",

  // ====== INVESTORS PATHS ========================
  investors: "/investors",
  investorsOverview: "/investors/overview",
  investorsStrategicCapital: "/investors/strategic-capital",
  investorsRiskGovernance: "/investors/risk-and-governance",
  investorsImpactReturns: "/investors/impact-and-returns",
  investorsReportsPublications: "/investors/reports-and-publications",
  investorsInvestmentOutlook: "/investors/investment-outlook",
  investorsFaq: "/investors/faq",
  investorsResources: "/investors/resources",
  investorsInvestmentPhilosophy: "/investors/investment-philosophy",

  // ====== CAREERS PATHS ========================
  careers: "/careers",
  careersAccendLife: "/careers/life-at-accend",
  careersCulture: "/careers/our-culture",
  careersCareerDevelopment: "/careers/career-development",
  careersInnovationAtAccend: "/careers/innovation-at-accend",
  careersDiversity: "/careers/diversity-at-accend",

  careersOpportunities: "/careers/opportunities",
  careersOpportunitiesForProfessionals: "/careers/opportunities/professionals",
  careersOpportunitiesForInterns: "/careers/opportunities/interns",
  careersOpportunitiesGlobalTalent: "/careers/opportunities/global-talent",
  careersOpenPositions: "/careers/open-positions",
  careersApply: "/careers/apply",

  // ====== NEWSROOM PATHS ========================
  newsroom: "/newsroom",
  newsroomArticle: "/newsroom/:slug",
  newsroomCompanyNews: "/newsroom/company-news",
  newsroomGroupUpdates: "/newsroom/group-update",
  newsroomInsights: "/newsroom/insights",
  newsroomEvents: "/newsroom/events",
  newsroomPressReleases: "/newsroom/press-releases",
  newsroomTopicsSearch: "/newsroom/search/topics",
  newsroomSignup: "/newsroom/signup",

  // ====== CONTACT PATHS ========================
  contact: "/contact",
  contactForInvestors: "/contact#investors",

  // ====== OTHER PATHS ========================
  search: "/search",
  sitemap: "/sitemap",
  privacyPolicy: "/privacy-policy",
  termsOfUse: "/terms-of-use",
  cookies: "/cookies",
};

export const routeBuilders = {
  businessesSector: (sectorSlug) =>
    `${routesConfig.businessesOperatingSectors}/${encodeURIComponent(sectorSlug)}`,
  
  businessesGroupCompanies: (commpanySlug) =>
    `${routesConfig.businessesGroupCompanies}/${encodeURIComponent(commpanySlug)}`,

  newsroomTopicsSearch: (topicSlug) =>
    `${routesConfig.newsroomTopicsSearch}/${encodeURIComponent(topicSlug)}`,

  newsroomArticle: (slug) =>
    `${routesConfig.newsroom}/${encodeURIComponent(slug)}`,
};